import {
  DealerProfile,
  Layout as AuthenticationLayout,
  RequireAuth,
} from "@poseidon/features/feature/Authentication";
import {
  ApplicationsOutlet,
  EditApplication,
  ListApplications,
} from "@poseidon/features/feature/DealerApplications";
import OutletWithCrumb from "@poseidon/ui/app/crumbs/OutletWithCrumb";
import { DashboardLayout } from "@poseidon/ui/app/layout/DashboardLayout";
import config from "@poseidon/utils/config";
import { Navigate, Route, Routes } from "react-router-dom";

export function DealerRoutes() {
  return (
    <Routes>
      <Route path="/auth/*" element={<AuthenticationLayout allowRegister />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <DashboardLayout app="dealer" navItems={config.dealerNavigation} />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/applications" replace />} />
        <Route path="applications" element={<ApplicationsOutlet />}>
          <Route index element={<ListApplications />} />
          <Route
            path=":applicationId"
            element={
              <OutletWithCrumb
                to="/applications/{applicationId}"
                docRef="/applicationsSummary/{applicationId}"
                crumb={({ data: applications }) =>
                  applications.applicationNumber
                }
              />
            }
          >
            <Route index element={<EditApplication />} />
          </Route>
        </Route>
        <Route path="profile" element={<DealerProfile />} />
      </Route>
      <Route
        path="*"
        element={
          <main style={{ padding: "1rem" }}>
            <p>There's nothing here!</p>
          </main>
        }
      />
    </Routes>
  );
}
